/*
 * @Description:
 * @Date: 2020-07-18 16:13:15
 */

import { BI } from '@/api/ajax';
import combination from './combination';
import makeSceneTarget from './makeSceneTarget';
import { percentage } from '@/tools/index';
import {
  createLineSeries,
  createBarSeries,
  createMapSeries1
} from '../components/Echarts/echartOption';
import {
  getRadioOptions,
  getMultipleChoiceOptions,
  getGradeOptions
} from '../components/Echarts/random';
import { axisFormatter, dealTips } from '../tools/index';

// 1单选  2多选  3单项投票  4单项填空 5多项填空 6打分题  7姓名手机邮箱-单选填空 8上传附件
// 9 pdf 10 word 11 excel 12 ppt 13 jpg/png 14时间-单选填空 15月度--按年月分开做两张报表 16定位 17 描述题 18 描述题 19数字题
// TODO: 9 10 11 12 13没有UI
// TODO: 16没数据
const questionMap = {
  1: '单选题',
  2: '多选题',
  3: '文字投票题-单选',
  4: '填空题',
  5: '多项填空题',
  6: '打分题',
  7: '填空题',
  14: '时间题',
  15: '月度题',
  17: '描述题',
  18: '描述题',
  19: '数字题',
  20: '签名题'
};
const typeFuncs = {
  type1(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark, optionJson } = im;
    let finalData = im.finalData || {};
    let header = [
      { label: '选项', prop: 'd' },
      { label: '任务数（单）', prop: 'v' },
      { label: '百分比(%)', prop: 'b' }
    ];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    let keys = Object.keys(finalData);
    try {
      keys = JSON.parse(optionJson);
    } catch (error) {}
    keys.forEach(m => {
      xAxisData.push(m);
      series0data.push({
        value: finalData[m],
        name: m,
        b: finalData[m] + '单'
      });
      data.push({
        d: m,
        v: finalData[m],
        b: percentage(finalData[m], finalDataCount)
      });
    });
    return getRadioOptions({
      ix,
      remark,
      title,
      questionType: questionMap[type],
      isMustFill,
      header,
      data: data,
      finalDataCount,
      xAxisData,
      series0data: series0data
    });
  },
  type2(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark, optionJson } = im;
    let finalData = im.finalData || {};
    let header = [
      { label: '选项', prop: 'd' },
      { label: '任务数（单）', prop: 'v' },
      { label: '百分比(%)', prop: 'b' }
    ];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    let keys = Object.keys(finalData);
    try {
      keys = JSON.parse(optionJson);
    } catch (error) {}
    keys.forEach(m => {
      xAxisData.push(m);
      series0data.push({
        value: finalData[m],
        name: m,
        b: finalData[m] + '单'
      });
      data.push({
        d: m,
        v: finalData[m],
        b: percentage(finalData[m], finalDataCount)
      });
    });
    return getMultipleChoiceOptions({
      ix,
      title,
      remark,
      questionType: questionMap[type],
      isMustFill,
      header,
      data,
      finalDataCount,
      xAxisData,
      series0data
    });
  },
  type3(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark, optionJson } = im;
    let finalData = im.finalData || {};

    let header = [
      { label: '选项', prop: 'd' },
      { label: '任务数（单）', prop: 'v' },
      { label: '百分比(%)', prop: 'b' }
    ];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    let keys = Object.keys(finalData);
    try {
      keys = JSON.parse(optionJson);
    } catch (error) {}
    keys.forEach(m => {
      xAxisData.push(m);
      series0data.push({
        value: finalData[m],
        name: m,
        b: finalData[m] + '单'
      });
      data.push({
        d: m,
        v: finalData[m],
        b: percentage(finalData[m], finalDataCount)
      });
    });
    return {
      key: 'type3-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        echart: [
          {
            echartType: 'line',
            echartOption: {
              tooltip: {
                formatter: function(params) {
                  const { axisValue, value } = params[0] || params || {};
                  return dealTips(axisValue, value, '单');
                }
              },
              xAxis: {
                type: 'category',
                data: xAxisData,
                name: '选项',
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    color: '#666',
                    fontSize: 11,
                    lineHeight: 18
                  },
                  formatter: function(params) {
                    return axisFormatter(params, xAxisData.length);
                  }
                }
              },
              yAxis: {
                name: '任务数（单）'
              },
              series: createLineSeries(series0data)
            }
          }
        ]
      }
    };
  },
  type4(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || [];
    let header = [{ label: '答案', prop: 'd' }];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    finalData.forEach(m => {
      data.push({
        d: m
      });
    });
    return {
      key: 'type4-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        customComponents: [
          {
            options: {
              series0data: data,
              finalDataCount: finalDataCount
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  },
  type5(im, ix) {
    let { type, title, finalDataCount, isMustFill, manyTitleJson, remark } = im;
    let finalData = im.finalData || [];
    let formatData = []; // 二维数组
    manyTitleJson = manyTitleJson
      ? manyTitleJson
          .replace(/\[\"|\"\]/g, '')
          .replace(/\"/g, '')
          .split(',')
      : [];
    finalData.forEach((item, index) => {
      item = item
        ? item
            .replace(/\[\"|\"\]/g, '')
            .replace(/\"/g, '')
            .split(',')
        : [];
      item.forEach((item2, index2) => {
        if (!formatData[index]) {
          formatData[index] = [item2];
        } else {
          formatData[index].push(item2);
        }
      });
    });
    let header = [];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    manyTitleJson.forEach((item, index) => {
      header.push({
        label: item,
        prop: `d${index}`
      });
    });
    formatData.forEach((item, index) => {
      let d = {};
      item.forEach((item2, index2) => {
        d[`d${index2}`] = item2;
      });
      data.push(d);
    });

    return {
      key: 'type5-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        customComponents: [
          {
            options: {
              isMultiple: true,
              header,
              series0data: data,
              finalDataCount: finalDataCount
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  },
  type6(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || {};
    let header = [
      { label: '评分', prop: 'd' },
      { label: '任务数（单）', prop: 'v' },
      { label: '百分比(%)', prop: 'b' }
    ];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    let total = 0; // 总分
    Object.entries(finalData).forEach(m => {
      total += m[0] * m[1];
      xAxisData.push(m[0] + '分');
      series0data.push({
        value: m[1],
        name: m[0],
        b: m[1] + '单'
      });
      // header.push({
      //   label: m[0] + '分',
      //   prop: `d${m[0]}`
      // });
      // data[0]['d' + m[0]] = percentage(m[1], finalDataCount);
      data.push({
        d: m[0],
        v: m[1],
        b: percentage(m[1], finalDataCount)
      });
    });
    data.push({
      d: '平均分',
      v: percentage(total, finalDataCount, { multiple: 1, symbol: '' }),
      b: '-'
    });
    return getGradeOptions({
      ix,
      title,
      remark,
      questionType: questionMap[type],
      isMustFill,
      header,
      data,
      finalDataCount,
      xAxisData,
      series0data
    });
  },
  type7(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || [];

    let header = [{ label: '答案', prop: 'd' }];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    finalData.forEach(m => {
      data.push({
        d: m
      });
    });
    return {
      key: 'type7-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        customComponents: [
          {
            options: {
              series0data: data,
              finalDataCount: finalDataCount
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  },
  type14(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || [];
    let header = [{ label: '答案', prop: 'd' }];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    finalData.forEach(m => {
      data.push({
        d: m
      });
    });
    return {
      key: 'type14-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        customComponents: [
          {
            options: {
              series0data: data,
              finalDataCount: finalDataCount
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  },
  type15(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || { year: [], month: [] };
    let year = finalData.year || {};
    let month = finalData.month || {};
    let data = [];
    let xAxisData = [];
    let series0data = [];
    Object.entries(year).forEach(m => {
      series0data.push({ value: m[1], name: m[0] + '年' });
    });
    let header = [{ label: '月份', prop: 'd' }];
    let monthData = [];
    let monthXAxisData = [];
    let monthSeries0data = [];
    let dv = { d: '任务数（单）' };
    let formatMonth = month.sort((a, b) => {
      return +Object.keys(a)[0] - Object.keys(b)[0];
    });
    Object.entries(formatMonth).forEach((m, i) => {
      let v = Object.values(m[1])[0];
      monthXAxisData.push(+m[0] + 1 + '月');
      monthSeries0data.push(v);
      header.push({ label: +m[0] + 1 + '月', prop: `d${i}` });
      dv[`d${i}`] = v;
    });
    monthData.push(dv);
    return {
      key: 'type15-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        table: { header, data: monthData, finalDataCount, isNormal: true },
        echart: [
          {
            echartType: 'line',
            echartOption: {
              tooltip: {
                formatter: function(params) {
                  const { axisValue, value } = params[0] || params || {};
                  return dealTips(axisValue, value, '单');
                }
              },
              xAxis: {
                type: 'category',
                name: '月份',
                axisLabel: {
                  interval: 0
                },
                data: monthXAxisData
              },
              yAxis: {
                name: '任务数（单）'
              },
              series: createLineSeries(monthSeries0data)
            }
          }
        ]
      }
    };
  },
  type17(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || [];
    let data = [];
    finalData.forEach(m => {
      data.push({
        d: m
      });
    });
    return {
      key: 'type19-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill: 2
        },
        customComponents: [
          {
            options: {
              series0data: [{ d: remark || '' }],
              type
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  },
  type18(im, ix) {
    let { type, title, finalDataCount, remark, optionJson, isMustFill } = im;
    let d = '';
    try {
      d = JSON.parse(optionJson).join(',') || '';
    } catch (error) {}
    return {
      key: 'type19-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill: 2
        },
        customComponents: [
          {
            options: {
              series0data: [{ d: d }],
              type
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  },
  type19(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || [];
    let data = [];
    finalData.forEach(m => {
      data.push({
        d: m
      });
    });
    return {
      key: 'type19-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        customComponents: [
          {
            options: {
              series0data: data,
              finalDataCount: finalDataCount
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  },
  type20(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || [];
    let data = [];
    finalData.forEach(m => {
      data.push({
        d: m
      });
    });
    return {
      key: 'type20-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: '',
          remark: '具体答案详情请查看附件',
          isMustFill,
          hideNoMore: true
        },
        customComponents: [
          {
            options: {
              series0data: data,
              finalDataCount: finalDataCount
            }
          }
        ]
      }
    };
  }
};

const dateQuestions = (visitingTimeDay, visitingTimeHour, timeTitle) => {
  let visitingTimeDayXAxisData = [];
  let visitingTimeDaySeries0data = [];
  visitingTimeDay.forEach(item => {
    let [m] = Object.entries(item);
    visitingTimeDayXAxisData.push(m[0]);
    visitingTimeDaySeries0data.push(m[1]);
  });

  let visitingTimeHourXAxisData = [];
  let visitingTimeHourSeries0data = [];
  let tableData = [];
  let dataCount = visitingTimeHour.reduce((pre, cur) => {
    let [m] = Object.entries(cur);
    pre += m[1];
    return pre;
  }, 0);
  visitingTimeHour.forEach(item => {
    let [m] = Object.entries(item);
    visitingTimeHourXAxisData.push(m[0]);
    visitingTimeHourSeries0data.push(m[1]);
    const [x1, x2] = (m[0] || '').split('-');
    tableData.push({
      d: `${x1}-<br>${x2}`,
      v: m[1],
      b: percentage(m[1], dataCount)
    });
  });
  return [
    {
      key: 'querytaskVisitingTime',
      value: {
        header: {
          index: 5,
          title: timeTitle,
          name: '任务时间'
        },
        echart: [
          {
            echartType: 'line1',
            echartOption: {
              tooltip: {
                formatter: function(params) {
                  const { axisValue, value } = params[0] || params || {};
                  return dealTips(axisValue, value, '单');
                }
              },
              xAxis: {
                type: 'category',
                name: '日',
                axisLabel: {
                  interval: 0
                },
                data: visitingTimeDayXAxisData
              },
              yAxis: {
                name: '任务数（单）'
              },
              series0data: visitingTimeDaySeries0data
            }
          }
        ]
      }
    },
    {
      key: 'querytaskVisitingTime1',
      value: {
        header: {
          hideHeader: true,
          title: '每日时间分布',
          name: '每日时间分布'
        },
        table: {
          header: [
            { label: '时间段', prop: 'd' },
            { label: '任务数（单）', prop: 'v' },
            { label: '百分比(%)', prop: 'b' }
          ],
          data: tableData,
          finalDataCount: dataCount
        },
        echart: [
          {
            echartType: 'bar2',
            echartOption: {
              tooltip: {
                formatter: function(params) {
                  const { axisValue, value } = params[0] || params || {};
                  return dealTips(axisValue, value, '单');
                }
              },
              xAxis: {
                type: 'category',
                data: visitingTimeHourXAxisData,
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    color: '#666',
                    fontSize: 12
                  }
                }
              },
              yAxis: {
                name: '任务数（单）'
              },
              series: createBarSeries(visitingTimeHourSeries0data, true)
            }
          }
        ]
      }
    }
  ];
};

const locationQuestions = (datas = [], locationTitle) => {
  return {
    key: 'querytaskHospitalDistribution',
    value: {
      header: {
        index: 1,
        title: locationTitle,
        name: '位置分布'
      },
      useMapLayout: false,
      echart: [
        {
          echartType: 'map',
          echartStyle: { height: '500px' },
          echartOption: {
            series: createMapSeries1(datas)
          }
        }
      ]
    }
  };
};

export default {
  query: {},
  // 上部分
  ...combination,
  // 问卷题型，该内容类型较多
  // 1单选  2多选  3单项投票  4单项填空 5多项填空 6打分题  7姓名手机邮箱-单选填空 8上传附件
  // 9 pdf 10 word 11 excel 12 ppt 13 jpg/png 14时间-单选填空 15月度--按年月分开做两张报表 16定位
  queryQuestionnaireDetailInfo() {
    return new Promise(async (resolve, reject) => {
      let combination = [];
      const targetRes = await BI[
        this.query.serviceType
      ].queryQuestionnaireTargetDetailInfo(this.query);
      // 可配置场景目标题型
      if (targetRes.data.data) {
        let {
          data: {
            data: { targetTotalInfo, targetType, targetTitle, targetCount }
          }
        } = targetRes;
        // targetType = 1;
        // targetTotalInfo = {
        //   customerCount: 1,
        //   dutyNameCount: { 主任医师: 1 },
        //   jobTitleCount: { 主任医师: 1 },
        //   fullNameCount: { 主任医师: 1 },
        //   firstDepartmentNameCount: { 其他: 1 },
        //   gradeNameCount: { 其他其他其他: 1 },
        //   hospitalNameCount: { 重庆市巴南区卫生服务中心: 1 },
        //   categoryCustomerCount: {
        //     finalDataCount: 2,
        //     finalData: [{ provinceId: 1500, provinceName: '安徽省', cc: 2 }]
        //   },
        //   genderCount: {
        //     boyCount: 1,
        //     girlCount: 1,
        //     sumCount: 2
        //   },
        //   ageCount: {
        //     ageRange1Count: 0,
        //     ageRange2Count: 0,
        //     ageRange3Count: 0,
        //     ageRange4Count: 0,
        //     ageRange5Count: 2
        //   }
        // };
        if (makeSceneTarget[`targetType${targetType}`]) {
          combination.push(
            makeSceneTarget[`targetType${targetType}`]({
              ...targetTotalInfo,
              targetTitle,
              targetCount
            })
          );
        }
      }

      // 可配置场景时间题型
      const dateRes = await BI[
        this.query.serviceType
      ].queryQuestionnaireTimeTargetDetailInfo(this.query);
      if (dateRes.data.data) {
        let {
          data: {
            data: { timeday, timehour, timeTitle }
          }
        } = dateRes;
        combination.push(dateQuestions(timeday, timehour, timeTitle));
      }

      // 可配置场景定位题型
      const locationRes = await BI[
        this.query.serviceType
      ].queryQuestionnaireAddressTargetDetailInfo(this.query);
      try {
        if (locationRes.data.data && locationRes.data.data.data.length > 0) {
          combination.push(
            locationQuestions(
              locationRes.data.data.data,
              locationRes.data.data.locationTitle
            )
          );
        }
      } catch (error) {}

      let {
        data: { data }
      } = await BI[this.query.serviceType].queryQuestionnaireDetailInfo(
        this.query
      );
      data.forEach((item, index) => {
        if (typeFuncs[`type${item.type}`]) {
          combination.push(typeFuncs['type' + item.type](item, index + 1));
          // if (
          //   item.isMultiple == 1 ||
          //   item.finalDataCount > 0 ||
          //   item.type == 17
          // ) {
          //   // 必填题 || 答案数量大于0 || 描述题
          // }
        }
      });
      resolve(combination);
    });
  },
  async run(query) {
    this.query = query;
    let arr = [];
    for (let i in this) {
      if (
        this.hasOwnProperty(i) &&
        i !== 'run' &&
        typeof this[i] === 'function'
      ) {
        arr.push(this[i]());
      }
    }
    return new Promise((resolve, reject) => {
      Promise.all(arr)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};
